exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#print-order-form-modal>div[data-v-11d9e4fc]{transition:max-width .35s ease}#print-order-step-2[data-v-11d9e4fc]{display:none}.sent-buttons .left[data-v-11d9e4fc]{position:absolute;left:15px}@media (max-width:575px){.sent-buttons[data-v-11d9e4fc]{width:100%}.sent-buttons .left[data-v-11d9e4fc]{position:relative;left:0;display:block;width:100%}.sent-buttons .btn-xs-block[data-v-11d9e4fc]{width:100%}}", ""]);

// exports
